import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import Button from '../Button/button.component';
import { FooterStyle, Mensagem } from './dialog.style';

const WidgetDialog = (props) => {
	const {
		title,
		mensagem,
		confirmar,
		cancelar,
		textConfirmar,
		textCancelar,
		isOpen,
		fechar,
		size,
		icon,
	} = props;
	return (
		<React.Fragment>
			<Modal isOpen={isOpen} size={size}>
				<ModalHeader
					toggle={() => (fechar ? fechar() : cancelar())}
				>
					{icon && <i className={icon} />} {title || 'Mensagem'}

				</ModalHeader>
				<ModalBody>
					<div>
						<Mensagem>{mensagem || 'Operação realizada com sucesso!'}</Mensagem>
					</div>
					<FooterStyle>
						{cancelar && (
							<Button
								type='button'
								onClick={() => cancelar()}
								text={textCancelar || 'Cancelar'}
							/>
						)}
						<Button
							type='button'
							primary
							onClick={confirmar}
							text={textConfirmar || 'Ok'}
						/>
					</FooterStyle>
				</ModalBody>
			</Modal>
		</React.Fragment>
	);
};

export default WidgetDialog;
